<script>
import { getGroups } from '../api/groups';

export default {
  name: 'CpGroups',
  components: {
    CpButton: require('../button').default,
    CpBox: require('../box').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpGroup: require('./group-card').default,
    CpIcon: require('../icon').default,
    CpTextInput: require('../inputs/text').default,
    CpUnstyledButton: require('../unstyled-button').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    InfiniteLoading: require('vue-infinite-loading').default,
    scrollToTop: require('../mixins/utils.js').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  props: {
    query: { type: String },
    currentUser: { type: Object },
    officialGroup: { type: String },
    privacyGroup: { type: String },
    tags: { type: Array },
    states: { type: Array },
    type: { type: String },
  },
  data: () => ({
    groups: [],
    page: 0,
    searching: null,
  }),
  watch: {
    query: {
      handler(newValue, oldValue) {
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
    tags: {
      handler(newValue, oldValue) {
        if (!this.$root.isMobile) {
          this.scrollToTop();
        }
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
    states: {
      handler(newValue, oldValue) {
        if (!this.$root.isMobile) {
          this.scrollToTop();
        }
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
    officialGroup: {
      handler(newValue, oldValue) {
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
    privacyGroup: {
      handler(newValue, oldValue) {
        if (!this.$root.isMobile) {
          this.scrollToTop();
        }
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
    type: {
      handler(newValue, oldValue) {
        if (!this.$root.isMobile) {
          this.scrollToTop();
        }
        if (this.searching) {
          clearTimeout(this.searching);
        }
        this.searching = setTimeout(() => {
          this.page = 0;
          this.groups = [];
          this.searching = null;
        }, 500);
      },
    },
  },
  methods: {
    fetch($state) {
      getGroups({
        page: this.page,
        query: this.query,
        type: this.type,
        tags: this.tags,
        states: this.states,
        privacy: this.privacyGroup,
      })
        .then(response => {
          if (response.groups.length) {
            this.groups = this.groups.concat(response.groups);
            this.page += 1;
            if ($state) $state.loaded();
          } else {
            if ($state) $state.complete();
          }
        })
        .catch(error => {
          if ($state) $state.complete();
          console.warn(error);
        });
    },
    clearQuery() {
      this.query = '';
      this.handleSubmit();
    },
    handleSubmit() {
      if (this.searching) {
        clearTimeout(this.searching);
      }
      this.searching = setTimeout(() => {
        this.page = 0;
        this.groups = [];
        this.searching = null;
      }, 500);
    },
  },
};
</script>

<template>
  <cp-box>
    <!-- GROUPS FEED -->
    <cp-grid>
      <cp-grid-item v-for="group in groups" :key="group.id" :span="12" style="box-shadow: 3px 3px 10px 0 #e5e5e580">
        <cp-group :group="group" :current-user="currentUser" :type="type" />
      </cp-grid-item>
    </cp-grid>
    <transition name="feed-fade" mode="out-in">
      <div class="heading-4 text-center" v-if="searching" key="searching">
        <vue-simple-spinner v-margin="1" />
      </div>
      <infinite-loading @infinite="fetch" v-margin="1" v-else key="scrolling">
        <div slot="spinner">
          <div class="heading-4"><vue-simple-spinner v-margin="1" /> Loading Groups...</div>
        </div>
        <div slot="no-more">
          <div class="heading-4">That's all!</div>
        </div>
        <div slot="no-results">
          <div class="heading-4">We couldn't find any groups that matches {{ this.query }}</div>
        </div>
      </infinite-loading>
    </transition>
  </cp-box>
</template>

<style scoped>
.search-page__content {
  width: 100%;
  margin: 30px;
}
@media only screen and (max-width: 768px) {
  .search-page__content {
    margin: 15px auto;
  }
}
</style>
